<template>
  <Dialog :visible="true" modal :style="{ width: '30rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل قسم البانرات الإعلانية" @update:visible="$emit('close')">
    <div class="hb-note">
      <i class="pi pi-info-circle"></i>
      هذا القسم يعرض البانرات الإعلانية الحالية تلقائيًا. لإضافة/تعديل/حذف بانر
      <router-link to="/banners" @click="$emit('close')">اذهب إلى صفحة البانرات</router-link>.
    </div>

    <div class="form-field mt-3 hb-visibility">
      <label class="field-label">إظهار القسم في الصفحة الرئيسية</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'BannersEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    return { form: { is_active: !!this.section.is_active } };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, { is_active: this.form.is_active });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
.hb-note { font-size: 0.85rem; color: var(--text-secondary, #64748b); display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; }
</style>
